import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/User/Accounts/Accounts.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Connect = ({ asButton = false }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  return (
    <a
      className={clsx(styles['accounts__connect-link'], {
        [styles['accounts__connect-link_as-button']]: asButton,
      })}
      href={pathGen(ROUTES.USER_ADMITAD_ATTACH)}
    >
      {t('user::settings.accounts.connect')}
    </a>
  )
}
Connect.propTypes = { asButton: PropTypes.bool }

export default Connect
